/**
 * 변경 이력 페이지 — 모든 로그인 사용자 접근 가능 (viewer/sales/admin).
 *
 * - 조회는 모든 권한자 가능. viewer 는 금액성 필드 '***' 마스킹 (백엔드 처리).
 * - 되돌리기 버튼은 admin 에게만 노출 (AuditLogTab 내부 분기).
 *
 * 운영 정책 (2026-05-26):
 *   사용자가 자기 작업/타인 작업 추적 가능. 다만 데이터 변경 권한은 admin 만.
 */

import { AuditLogTab } from '../components/AuditLogTab';
import { LastUpdateBadge } from '../components/LastUpdateBadge';
import { useAuth } from '../lib/auth-context';

export function AuditLogPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  return (
    <div className="p-8">
      <h1 className="ui-page-title">변경 이력</h1>
      <p className="ui-page-sub">
        운영 데이터 변경 내역을 시간순으로 조회.
        {isAdmin ? ' 관리자는 변경 직전 상태로 되돌리기 가능.' : ' 조회만 가능합니다.'}
      </p>
      <LastUpdateBadge className="mb-5 mt-1" />
      <AuditLogTab />
    </div>
  );
}
